module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.237f4a0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/fontawesome-6.6.0/webfonts/fa-solid-900.woff2
// module id = nQoz
// module chunks = 2